import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "skg_cart";

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  // Track cart server-side for logged-in users (powers abandoned-cart reminders)
  useEffect(() => {
    if (!user) return;
    const t = setTimeout(() => {
      api.post("/cart/track", { items: items.map((i) => ({ name: i.name, color: i.color, size: i.size, quantity: i.quantity, image: i.image, price: i.price })) }).catch(() => {});
    }, 1500);
    return () => clearTimeout(t);
  }, [items, user]);

  const lineId = (i) => `${i.product_id}|${i.color}|${i.size}`;

  const addItem = (item, silent = false) => {
    setItems((prev) => {
      const id = lineId(item);
      const existing = prev.find((p) => lineId(p) === id);
      if (existing) {
        return prev.map((p) =>
          lineId(p) === id ? { ...p, quantity: Math.min(p.quantity + item.quantity, p.max_stock || 99) } : p
        );
      }
      return [...prev, item];
    });
    if (!silent) {
      toast.success("Προστέθηκε στο καλάθι", { description: `${item.name} · ${item.color} / ${item.size}` });
      setOpen(true);
    }
  };

  const updateQty = (id, qty) => {
    setItems((prev) => prev.map((p) => (lineId(p) === id ? { ...p, quantity: Math.max(1, qty) } : p)));
  };
  const removeItem = (id) => {
    setItems((prev) => prev.filter((p) => lineId(p) !== id));
    toast("Αφαιρέθηκε από το καλάθι");
  };
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, subtotal, count, open, setOpen, lineId }}
    >
      {children}
    </CartContext.Provider>
  );
}
